import React from 'react';

interface ViewProps {
  width?: number;
  height?: number;
}

export const RightImgView = ({ width = 66, height = 50 }: ViewProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 67 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.833344"
      y="0.5"
      width="39"
      height="49"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect
      x="44.8334"
      y="0.5"
      width="21"
      height="49"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect x="47.8334" y="3.5" width="15" height="43" rx="2" fill="#F3F4F6" />
    <path
      d="M51.4386 26.0044C51.5099 25.8979 51.609 25.8101 51.7267 25.7492C51.8444 25.6884 51.9767 25.6564 52.1112 25.6564C52.2458 25.6564 52.3781 25.6884 52.4958 25.7492C52.6134 25.8101 52.7126 25.8979 52.7839 26.0044L55.3333 29.812H48.8884L51.4378 26.0044H51.4386Z"
      fill="#DDE0E4"
    />
    <path
      d="M56.5574 22.7156C56.6232 22.5926 56.7245 22.4892 56.8498 22.4169C56.9751 22.3446 57.1196 22.3063 57.2669 22.3063C57.4142 22.3063 57.5586 22.3446 57.684 22.4169C57.8093 22.4892 57.9106 22.5926 57.9764 22.7156L61.7784 29.8126H52.7554L55.0114 25.6015L56.5581 22.7156H56.5574Z"
      fill="#DDE0E4"
    />
    <path
      d="M52.1114 23.7974C53.1794 23.7974 54.0452 22.9893 54.0452 21.9925C54.0452 20.9956 53.1794 20.1875 52.1114 20.1875C51.0433 20.1875 50.1775 20.9956 50.1775 21.9925C50.1775 22.9893 51.0433 23.7974 52.1114 23.7974Z"
      fill="#DDE0E4"
    />
  </svg>
);
